<template>
	<Portal :to="teleportTo" :disabled="!teleportTo">
		<div class="paypal-container">
			<button v-if="cta" class="btn btn-success" :class="classList">
				<span class="spinner-border spinner-border-sm"></span>
				<div class="btn__content">{{ cta }}</div>
			</button>
			<div id="paypal-button" class="paypal-button" :class="{ transparent: cta }"></div>
		</div>
	</Portal>
</template>

<script>
import { Portal } from 'portal-vue'

export default {
	name: 'PayPalButton',

	components: { Portal },

	props: {
		cta: {
			type: String || Boolean,
			default: false
		},
		classList: {
			type: Object,
			default: () => ({})
		},
		teleportTo: {
			type: String,
			default: null
		}
	}
}
</script>

<style lang="scss" scoped>
.paypal-container {
	position: relative;
	margin-top: 2rem;
	.btn {
		margin-top: 0;
	}
}

.paypal-button {
	&.transparent {
		position: absolute;
		top: 0;
		left: 0;
		width: 0;
		width: 100%;
		opacity: 0.0001;
		z-index: 1;
	}
}

.btn {
	position: relative;
	.spinner-border {
		position: absolute;
		left: 50%;
		top: 50%;
		margin-top: -0.68rem;
		margin-left: -0.68rem;
		opacity: 0;
	}

	&.loading {
		pointer-events: none;
		.spinner-border {
			opacity: 1;
		}
	}

	&.loading & {
		&__content {
			opacity: 0;
		}
	}
}
</style>
